import { actionTypes } from '../constants';
import { selectHasHouses } from '../houses/selectors';
import { selectCurrentName as selectCurrentCompanyName } from './selectors';

export const currentChanged =
  (company, hasHousesHandler) => (dispatch, getState) => {
    const state = getState();

    const _change = () => {
      dispatch({ type: actionTypes.currentCompanyChanged, payload: company });
    };

    if (selectHasHouses(state)) {
      hasHousesHandler({
        name: selectCurrentCompanyName(state),
        onOk: _change,
      });
      return;
    }

    _change();
  };

export const searchChanged = (value) => ({
  type: actionTypes.companySearchChanged,
  payload: value,
});
